import React, { Component } from 'react';

export default class EventSlot extends Component {
  get classes() {
    const classes = ['book-viewing-event__slot', 'slot'];

    if (this.props.selected) {
      classes.push('selected');
    }

    return classes.join(' ');
  }

  handleClick = (e) => {
    e.preventDefault();
    track_event('viewing-event', 'clicked', 'bookings');

    this.props.onClick(e);
  };

  render() {
    const slot = this.props.slot;

    return (
      <a
        className={this.classes}
        data-label={slot.timeLabel}
        data-event-id={slot.id}
        data-event-start={slot.startTime}
        data-ga-category="home-viewing-flow"
        data-ga-action="select-viewing-event"
        data-ga-label={slot.analyticsLabel}
        onClick={this.handleClick}
      >
        <strong>{slot.formattedStartDate}</strong>
        <br />
        {slot.formattedStartTime} - {slot.formattedEndTime}
      </a>
    );
  }
}
